<div class="wrapper-payment-method">
    <div class="section-text row">
        <div class="section-btn">
            <button class="btn btn-back rounded-circle mt-2">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <h1 class="title">Payments</h1>
        </div>
    </div>

    <div class="section-main">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card h-1">
                    <img class="paypal-logo" src="../../../assets/payment-logo/paypal-1.png" alt="paypal">
                    <h4 class="title">Express Checkout</h4>
                    <p class="subtitle">
                        A button that enables customers to use PayPal directly from your checkout. 
                        <button class="btn btn-link">Learn more about PayPal </button>
                    </p>
                    <p class="subtitle-2">
                        Receive payments in foreign currencies with PayPal. 
                        <button class="btn btn-link">Learn more</button>
                    </p>
                    <button class="btn btn-choose">Enable Paypal</button>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card h-1 mt-25">
                    <h4 class="title">Third-party providers</h4>
                    <p class="subtitle">
                        Providers that enable you to accept payment methods at a rate set by 
                        the third-party. An additional fee will apply to new orders once you
                        <button class="btn btn-link">select a plan</button>
                    </p>
                    <button class="btn btn-choose">Choose Provider</button>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card h-2">
                    <h4 class="title">Alternative payment methods</h4>
                    <p class="subtitle">
                        External payment methods that can be used in addition to either a third-party 
                        provider or Shopify Payments.
                    </p>
                    <button class="btn btn-choose">Choose Provider</button>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card h-2 mt-25">
                    <h4 class="title">Manual payment methods</h4>
                    <p class="subtitle">
                        Payments that are processed outside your online store. When 
                        a customer makes a manual payment, you need to approve their order before fulfilling.
                    </p>
                    <button class="btn btn-choose">Choose Provider</button>
                </div>
            </div>
        </div>
    </div>
</div>